<template>
  <div class="control is-vertical">
    <div class="control is-grouped">
      <p class="control" v-if="(!service.service_extend_card || service.service_extend_card.vc_status === 'CANCELLED' || service.service_extend_card.vc_status === 'EXPIRED') && !service.service_clara_card || service.service_clara_card.vc_card_status === 'LOCKED'" style="min-width: 450px;">
        <label class="label">Choose Card Type</label>
        <select class="select" style="min-width: 290px;" v-model="card_type" name="card_type" id="card_type" >
          <option value="0">Select Card Type</option>
          <option v-if="parseInt($store.state.config.user.extend_card) === 1" value="1">Extend</option>
          <option v-if="parseInt($store.state.config.user.extend_card) === 1" value="2">Clara</option>
          <option v-if="parseInt($store.state.config.user.extend_card) === 1" value="4">Jeeves</option>
          <option value="3">Others</option>
        </select>
      </p>
    </div>
    <div class="control is-grouped" v-if="card_type == 3">
      <p class="control is-expanded">
        <label class="label">Card</label>
        <input :class="{'input': true, 'is-danger': (cardErrors.cardNumber !== '')}" v-cardformat:formatCardNumber v-model="cardNumber">
        <span class="help is-danger">{{ cardErrors.cardNumber }}</span>
      </p>
      <p class="control is-expanded">
        <label class="label">Holder</label>
        <input :class="{'input': true, 'is-danger': (cardErrors.cardHolder !== '')}" v-model="cardHolder">
        <span class="help is-danger">{{ cardErrors.cardHolder }}</span>
      </p>
      <p class="control is-expanded">
        <label class="label">Expiry</label>
        <input :class="{'input': true, 'is-danger': (cardErrors.cardExpiry !== '')}" v-cardformat:formatCardExpiry v-model="cardExpiry">
        <span class="help is-danger">{{ cardErrors.cardExpiry }}</span>
      </p>
      <p class="control is-expanded">
        <label class="label">CVC</label>
        <input :class="{'input': true, 'is-danger': (cardErrors.cardCVC !== '')}" v-cardformat:formatCardCVC v-model="cardCvc">
        <span class="help is-danger">{{ cardErrors.cardCVC }}</span>
      </p>
    </div>
    <!--EXTEND-->
    <div class="control is-grouped" v-if="card_type == 1 || cardType == 1">
      <p class="control" v-if="!service.service_extend_card || service.service_extend_card.vc_status === 'CANCELLED' || service.service_extend_card.vc_status === 'EXPIRED'" style="min-width: 290px;">
        <label class="label">Extend Main Card</label>
        <v-select
          :options="parseCards(cards)"
          placeholder="Select Extend Main Card"
          label="name"
          v-model="cardMain"
          >
        </v-select>
        <span class="help is-danger">{{ cardErrors.cardMain }}</span>
      </p>
      <p class="control" v-if="service.service_extend_card && service.service_extend_card.vc_status === 'ACTIVE'">
        <label class="label">New Balance</label>
        <input class="input" type="number" name="new_balance" id="new_balance" v-model="new_balance">
        <span class="help is-danger">{{ cardErrors.new_balance }}</span>
      </p>
      <a v-if="service.service_extend_card && service.service_extend_card.vc_status === 'ACTIVE' && service.service_extend_card.tx_status !== 'PENDING'" :class="{'button': true, 'is-info': true}" style="margin-top: 20px;" @click="updateCard(true)" :disabled="email === undefined ? true : (email ?  email.trim() === '' : true)">Update Card</a>
      <div v-if="!service.service_extend_card || service.service_extend_card.vc_status === 'CANCELLED' || service.service_extend_card.vc_status === 'EXPIRED'">
        <a :class="{'button': true, 'is-info': true}" style="margin: 20px 10px 0px 0px;" @click="sendCard(false)">Change Card</a>
        <a :class="{'button': true, 'is-danger': true}" style="margin-top: 20px;" @click="sendCard(true)" :disabled="email === undefined ? true : (email ?  email.trim() === '' : true)">Change/Send Card</a>
      </div>
    </div>
    <!--CLARA-->
    <div class="control is-grouped" v-if="card_type == 2 || cardType == 2">
      <p class="control" v-if="service.service_clara_card && service.service_clara_card.vc_card_status === 'ACTIVE'">
        <label class="label">New Balance</label>
        <input class="input" type="number" name="new_balance" id="new_balance" v-model="new_balance">
        <span class="help is-danger">{{ cardErrors.new_balance }}</span>
      </p>
      <a v-if="service.service_clara_card && service.service_clara_card.vc_card_status === 'ACTIVE' && service.service_clara_card.vc_card_status !== 'AUTHORIZED'" :class="{'button': true, 'is-info': true}" style="margin-top: 20px;" @click="updateCardClara(true)" :disabled="email === undefined ? true : (email ?  email.trim() === '' : true)">Update Card</a>
      <div v-if="!service.service_clara_card || service.service_clara_card.vc_card_status === 'LOCKED'">
        <a :class="{'button': true, 'is-info': true}" style="margin: 20px 10px 0px 0px;" @click="sendCard(false)">Change Card</a>
        <a :class="{'button': true, 'is-danger': true}" style="margin-top: 20px;" @click="sendCard(true)" :disabled="email === undefined ? true : (email ?  email.trim() === '' : true)">Change/Send Card</a>
      </div>
    </div>
    <!--OTHER-->
    <div class="control is-grouped" v-if="card_type == 3">
      <p class="control" style="min-width: 290px;">
        <label class="label">Main Card</label>
        <v-select
          :options="parseCards(cards)"
          placeholder="Select Main Card"
          label="name"
          v-model="cardMain"
          >
        </v-select>
        <span class="help is-danger">{{ cardErrors.cardMain }}</span>
      </p>
      <div>
        <a :class="{'button': true, 'is-info': true}" style="margin: 20px 10px 0px 0px;" @click="sendCard(false)">Change Card</a>
        <a :class="{'button': true, 'is-danger': true}" style="margin-top: 20px;" @click="sendCard(true)" :disabled="email === undefined ? true : (email ?  email.trim() === '' : true)">Change/Send Card</a>
      </div>
    </div>
    <div class="control is-grouped" v-if="card_type == 4 || cardType == 4">
      <p class="control" v-if="service.service_jeeves_card && service.service_jeeves_card.vc_card_status === 'ACTIVE'">
        <label class="label">New Balance</label>
        <input class="input" type="number" name="new_balance" id="new_balance" v-model="new_balance">
        <span class="help is-danger">{{ cardErrors.new_balance }}</span>
      </p>
      <a v-if="service.service_jeeves_card && service.service_jeeves_card.vc_card_status === 'ACTIVE' && service.service_jeeves_card.vc_card_status !== 'AUTHORIZED'" :class="{'button': true, 'is-info': true}" style="margin-top: 20px;" @click="updateCardJeeves(true)" :disabled="email === undefined ? true : (email ?  email.trim() === '' : true)">Update Card</a>
      <div v-if="!service.service_jeeves_card || service.service_jeeves_card.vc_card_status === 'LOCKED'">
        <a :class="{'button': true, 'is-info': true}" style="margin: 20px 10px 0px 0px;" @click="sendCard(false)">Change Card</a>
        <a :class="{'button': true, 'is-danger': true}" style="margin-top: 20px;" @click="sendCard(true)" :disabled="email === undefined ? true : (email ?  email.trim() === '' : true)">Change/Send Card</a>
      </div>
    </div>
    <span v-if="!email && !updateEmail"><a @click="updateEmail = 1">E-mail financeiro do hotel não cadastrado - clique aqui para cadastrar</a></span>
    <p v-if="updateEmail" class="control">
      <label class="label">Financial Email</label>
      <input style="width: 200px" :class="{'input': true, 'is-danger': errors.has('email'), 'is-disabled': inProgress}" type="email" name="email" id="email" placeholder="Email" v-model="financial_email" v-validate="'required'">
      <button class="button" style="background: #91181c; color: white" @click="updateHotelFinancialEmail()">Update Email</button> <span v-show="errors.has('email')" class="help is-danger">{{ errors.first('email') }}</span>
    </p>
  </div>
</template>

<script>
  import message from '../../utils/message'
  import vSelect from 'vue-select'
  import 'vue-select/dist/vue-select.css'
  export default {
    props: {
      service: {
        type: Object
      },
      email: {
        type: String
      },
      cardType: {
        type: Number
      }
    },
    data () {
      return {
        cardNumber: '',
        cardHolder: '',
        cardCvc: '',
        cardExpiry: '',
        cardBrand: '',
        cardMain: '',
        cardErrors: {
          cardNumber: '',
          cardExpiry: '',
          cardCVC: '',
          cardHolder: '',
          cardMain: '',
          new_balance: ''
        },
        new_balance: 0,
        card_type: 0,
        cardError: false,
        cards: [],
        updateEmail: null,
        hotel_id: this.service.room.hotel_id,
        financial_email: '',
        inProgress: false,
        error: ''
      }
    },
    mounted () {
      this.$nextTick(() => {
        this.loadCards()
      })
    },
    methods: {
      updateHotelFinancialEmail () {
        if (window.confirm('Are you sure you want to update the hotel financial e-mail?')) {
          this.$validator.validateAll().then(() => {
            if (this.errors.items.length === 0) {
              this.inProgress = true
              this.error = ''
              let url = this.$store.state.config.apiURL + '/hotels/' + this.hotel_id
              this.$http.post(url, {financial_email_from_service: this.financial_email}).then((response) => {
                this.inProgress = false
                this.message('success', 'Success', 'The new hotel financial e-mail was successfully updated')
                setTimeout(() => {
                  window.location.reload()
                }, 2000)
              }, (response) => {
                this.inProgress = false
                this.message('danger', 'Error', response.body)
              })
            }
          })
        }
      },
      parseCards (data) {
        let cards = []
        let brand = ''
        for (var i = 0; i < data.length; i++) {
          switch (data[i].brand) {
            case 'AMERICAN-EXPRESS':
              brand = 'AX'
              break
            case 'VISA':
              brand = 'VI'
              break
            case 'MASTERCARD':
              brand = 'MC'
              break
          }
          if (this.cards[i].vc_card_id !== null && this.card_type === '1' && this.cards[i].hide === 0) {
            if (data[i].nationality === 1) {
              cards.push({name: brand + '-' + data[i].card + ' ( ' + 'NATIONAL' + ' - ' + data[i].bank + ' - ' + data[i].holder + ')', value: data[i].id})
            } else if (data[i].nationality === 2) {
              cards.push({name: brand + '-' + data[i].card + ' ( ' + 'MULTI' + ' - ' + data[i].bank + ' - ' + data[i].holder + ')', value: data[i].id})
            } else {
              cards.push({name: brand + '-' + data[i].card + ' ( ' + 'INTERNATIONAL' + ' - ' + data[i].bank + ' - ' + data[i].holder + ')', value: data[i].id})
            }
          } else if (this.cards[i].vc_card_id === null && this.card_type === '2' && this.cards[i].hide === 0) {
            if (data[i].nationality === 1) {
              cards.push({name: brand + '-' + data[i].card + ' ( ' + 'NATIONAL' + ' - ' + data[i].bank + ' - ' + data[i].holder + ')', value: data[i].id})
            } else if (data[i].nationality === 2) {
              cards.push({name: brand + '-' + data[i].card + ' ( ' + 'MULTI' + ' - ' + data[i].bank + ' - ' + data[i].holder + ')', value: data[i].id})
            } else {
              cards.push({name: brand + '-' + data[i].card + ' ( ' + 'INTERNATIONAL' + ' - ' + data[i].bank + ' - ' + data[i].holder + ')', value: data[i].id})
            }
          } else if (this.card_type === '3' && this.cards[i].hide === 0) {
            if (data[i].nationality === 1) {
              cards.push({name: brand + '-' + data[i].card + ' ( ' + 'NATIONAL' + ' - ' + data[i].bank + ' - ' + data[i].holder + ')', value: data[i].id})
            } else if (data[i].nationality === 2) {
              cards.push({name: brand + '-' + data[i].card + ' ( ' + 'MULTI' + ' - ' + data[i].bank + ' - ' + data[i].holder + ')', value: data[i].id})
            } else {
              cards.push({name: brand + '-' + data[i].card + ' ( ' + 'INTERNATIONAL' + ' - ' + data[i].bank + ' - ' + data[i].holder + ')', value: data[i].id})
            }
          } else if (this.cards[i].vc_card_id === null && this.card_type === '4' && this.cards[i].hide === 0) {
            if (data[i].nationality === 1) {
              cards.push({name: brand + '-' + data[i].card + ' ( ' + 'NATIONAL' + ' - ' + data[i].bank + ' - ' + data[i].holder + ')', value: data[i].id})
            } else if (data[i].nationality === 2) {
              cards.push({name: brand + '-' + data[i].card + ' ( ' + 'MULTI' + ' - ' + data[i].bank + ' - ' + data[i].holder + ')', value: data[i].id})
            } else {
              cards.push({name: brand + '-' + data[i].card + ' ( ' + 'INTERNATIONAL' + ' - ' + data[i].bank + ' - ' + data[i].holder + ')', value: data[i].id})
            }
          }
        }
        return cards
      },
      loadCards () {
        this.$http.get(this.$store.state.config.apiURL + '/finances/cardsMain').then((response) => {
          this.cards = response.body
        }, (response) => {

        })
      },
      updateCard (sendEmail) {
        if (window.confirm('Are you sure you want to UPDATE this Virtual Card?')) {
          this.cardError = false
          if (this.card_type === '1' || this.cardType === 1) {
            this.cardErrors.new_balance = ''
            if (this.new_balance <= 0) {
              this.cardErrors.new_balance = 'Invalid Balance Amount.'
              this.cardError = true
            } else {
              this.cardErrors.new_balance = ''
            }
            if (!this.cardError) {
              let data = null
              if (sendEmail) {
                data = {vc_id: this.service.vc_id, new_balance: this.new_balance, sendEmail: sendEmail, email: this.email}
              } else {
                data = {vc_id: this.service.vc_id, new_balance: this.new_balance, sendEmail: sendEmail, email: ''}
              }
              this.$http.post(this.$store.state.config.apiURL + '/services/' + this.service.id + '/update_card_extend', data).then((response) => {
                if (response.body === 'Error') {
                  this.message('danger', 'Error', 'The system was not able to update the card. Try again in a few seconds.')
                } else {
                  this.message('success', 'Success', 'The extend card has been successfully updated.')
                  setTimeout(() => {
                    window.location.reload()
                  }, 3000)
                }
              }, (response) => {
                this.message('danger', 'Error', response.body)
              })
            }
          }
        }
      },
      updateCardClara (sendEmail) {
        if (window.confirm('Are you sure you want to UPDATE this Clara Card?')) {
          this.cardError = false
          if (this.card_type === '2' || this.cardType === 2) {
            this.cardErrors.new_balance = ''
            if (this.new_balance <= 0) {
              this.cardErrors.new_balance = 'Invalid Balance Amount.'
              this.cardError = true
            } else if (this.new_balance > this.service.provider_price) {
              this.cardErrors.new_balance = 'Invalid Balance Amount.'
              this.cardError = true
            } else {
              this.cardErrors.new_balance = ''
            }
            if (!this.cardError) {
              let data = null
              if (sendEmail) {
                data = {clara_uuid: this.service.clara_uuid, new_balance: this.new_balance, sendEmail: sendEmail, email: this.email}
              } else {
                data = {clara_uuid: this.service.clara_uuid, new_balance: this.new_balance, sendEmail: sendEmail, email: ''}
              }
              this.$http.post(this.$store.state.config.apiURL + '/services/' + this.service.id + '/update_card_clara', data).then((response) => {
                if (response.body === 'Error') {
                  this.message('danger', 'Error', 'The system was not able to update the card. Try again in a few seconds.')
                } else {
                  this.message('success', 'Success', 'The Clara card has been successfully updated.')
                  setTimeout(() => {
                    window.location.reload()
                  }, 3000)
                }
              }, (response) => {
                this.message('danger', 'Error', response.body)
              })
            }
          }
        }
      },
      updateCardJeeves (sendEmail) {
        if (window.confirm('Are you sure you want to UPDATE this Jeeves Card?')) {
          this.cardError = false
          if (this.card_type === '4' || this.cardType === 4) {
            this.cardErrors.new_balance = ''
            if (this.new_balance <= 0) {
              this.cardErrors.new_balance = 'Invalid Balance Amount.'
              this.cardError = true
            } else if (this.new_balance > this.service.provider_price) {
              this.cardErrors.new_balance = 'Invalid Balance Amount.'
              this.cardError = true
            } else {
              this.cardErrors.new_balance = ''
            }
            if (!this.cardError) {
              let data = null
              if (sendEmail) {
                data = {jeeves_vc_id: this.service.vc_id, new_balance: this.new_balance, sendEmail: sendEmail, email: this.email}
              } else {
                data = {jeeves_vc_id: this.service.vc_id, new_balance: this.new_balance, sendEmail: sendEmail, email: ''}
              }
              this.$http.post(this.$store.state.config.apiURL + '/services/' + this.service.id + '/update_card_jeeves', data).then((response) => {
                if (response.body === 'Error') {
                  this.message('danger', 'Error', 'The system was not able to update the card. Try again in a few seconds.')
                } else {
                  this.message('success', 'Success', 'The Jeeves card has been successfully updated.')
                  setTimeout(() => {
                    window.location.reload()
                  }, 3000)
                }
              }, (response) => {
                this.message('danger', 'Error', response.body)
              })
            }
          }
        }
      },
      serviceValue () {

      },
      sendCard (sendEmail) {
        if (window.confirm('Are you sure you want to CREATE a new card?')) {
          this.cardError = false
          // Extend cards
          if (this.card_type === '1') {
            if (!this.cardMain) {
              this.cardErrors.cardMain = 'Invalid Main Card.'
              this.cardError = true
            } else {
              this.cardErrors.cardMain = ''
            }
            if (!this.cardError) {
              let data = null
              if (sendEmail) {
                data = {cardMain: this.cardMain.value, sendEmail: sendEmail, email: this.email}
              } else {
                data = {cardMain: this.cardMain.value, sendEmail: sendEmail, email: ''}
              }
              this.$http.post(this.$store.state.config.apiURL + '/services/' + this.service.id + '/card_extend', data).then((response) => {
                if (response.body === 'Error') {
                  this.message('danger', 'Error', 'The system was not able to create the card. Try again in a few seconds.')
                } else {
                  this.message('success', 'Success', 'The extend card has been successfully sent')
                  setTimeout(() => {
                    window.location.reload()
                  }, 3000)
                }
              }, (response) => {
                this.message('danger', 'Error', response.body)
              })
            }
          }
          // Clara cards
          if (this.card_type === '2') {
            if (!this.cardError) {
              let data = null
              if (sendEmail) {
                data = {sendEmail: sendEmail, email: this.email}
              } else {
                data = {sendEmail: sendEmail, email: ''}
              }
              this.$http.post(this.$store.state.config.apiURL + '/services/' + this.service.id + '/card_clara', data).then((response) => {
                if (response.body === 'Error') {
                  this.message('danger', 'Error', 'The system was not able to create the card. Try again in a few seconds.')
                } else {
                  this.message('success', 'Success', 'The clara card has been successfully sent')
                  setTimeout(() => {
                    window.location.reload()
                  }, 3000)
                }
              }, (response) => {
                this.message('danger', 'Error', response.body)
              })
            }
          }
          // Other cards
          if (this.card_type === '3') {
            this.cardErrors.cardNumber = ''
            this.cardErrors.cardHolder = ''
            this.cardErrors.cardExpiry = ''
            this.cardErrors.cardCVC = ''
            this.cardErrors.cardMain = ''
            // validate card number
            if (!this.$cardFormat.validateCardNumber(this.cardNumber)) {
              this.cardErrors.cardNumber = 'Invalid Credit Card Number.'
              this.cardError = true
            } else {
              this.cardErrors.cardNumber = ''
            }
            if (this.cardHolder.trim() === '') {
              this.cardErrors.cardHolder = 'Invalid Credit Card Holder.'
              this.cardError = true
            } else {
              this.cardErrors.cardHolder = ''
            }
            // validate card expiry
            if (!this.$cardFormat.validateCardExpiry(this.cardExpiry)) {
              this.cardErrors.cardExpiry = 'Invalid Expiration Date.'
              this.cardError = true
            } else {
              this.cardErrors.cardExpiry = ''
            }
            // validate card CVC
            if (!this.$cardFormat.validateCardCVC(this.cardCvc)) {
              this.cardErrors.cardCVC = 'Invalid CVC.'
              this.cardError = true
            } else {
              this.cardErrors.cardCVC = ''
            }
            if (!this.cardMain) {
              this.cardErrors.cardMain = 'Invalid Main Card.'
              this.cardError = true
            } else {
              this.cardErrors.cardMain = ''
            }
            if (!this.cardError) {
              let data = null
              if (sendEmail) {
                data = {cardNumber: this.cardNumber, cardHolder: this.cardHolder, cardCvc: this.cardCvc, cardExpiry: this.cardExpiry, cardBrand: this.cardBrand, cardMain: this.cardMain.value, sendEmail: sendEmail, email: this.email}
              } else {
                data = {cardNumber: this.cardNumber, cardHolder: this.cardHolder, cardCvc: this.cardCvc, cardExpiry: this.cardExpiry, cardBrand: this.cardBrand, cardMain: this.cardMain.value, sendEmail: sendEmail, email: ''}
              }
              this.$http.post(this.$store.state.config.apiURL + '/services/' + this.service.id + '/card', data).then((response) => {
                if (response.body !== 'ok') {
                  this.message('warning', 'Warning', response.body, 30000)
                } else {
                  this.message('success', 'Success', 'The card has been successfully sent')
                  setTimeout(() => {
                    window.location.reload()
                  }, 2000)
                }
              }, (response) => {
                this.message('danger', 'Error', response.body)
              })
            }
          }
          // Jeeves Card
          if (this.card_type === '4') {
            if (!this.cardError) {
              let data = null
              if (sendEmail) {
                data = {sendEmail: sendEmail, email: this.email}
              } else {
                data = {sendEmail: sendEmail, email: ''}
              }
              this.$http.post(this.$store.state.config.apiURL + '/services/' + this.service.id + '/card_jeeves', data).then((response) => {
                if (response.body === 'Error') {
                  this.message('danger', 'Error', 'The system was not able to create the card. Try again in a few seconds.')
                } else {
                  this.message('success', 'Success', 'The jeeves card has been successfully sent')
                  setTimeout(() => {
                    window.location.reload()
                  }, 3000)
                }
              }, (response) => {
                this.message('danger', 'Error', response.body)
              })
            }
          }
        }
      },
      message (type, title, content, duration = 4500) {
        let propsData = {
          title: title,
          message: content,
          type: type,
          direction: 'down',
          duration: duration,
          showCloseButton: true
        }
        message.openMessage(propsData)
      }
    },
    components: {
      vSelect
    }
  }
</script>



// WEBPACK FOOTER //
// Card.vue?031b0ec1